import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import useStyles from './Loader.styles';

interface ILoaderProps {
  size?: number;
}

const Loader: React.FC<ILoaderProps> = ({ size = 50 }) => {
  const classes = useStyles();
  return (
    <div className={classes.progress} data-qa-name="loader">
      <CircularProgress size={size} />
    </div>
  );
};

export default Loader;
